import { type EvaluationDetails, type FlagUser, getFlags } from '@tix/flags'

import { getEnv } from '@/helpers/environment'

import { errorTracker } from '@/services/errorTracking'

export type Flags = Partial<{
  // @see https://ticketure-team.atlassian.net/browse/TIC-4802
  hide_membership_links: boolean
  /** Enables selections summary sidebar. */
  flows_progress_sidebar: boolean
}>

let hasTrackedError = false

export function evaluateFlags(identity?: { id: string; email?: string }): Flags {
  const env = getEnv()
  const rules = env?.config_cat

  if (!rules) {
    trackError(new Error('ConfigCat embed missing'))
    return {}
  }

  const tenant = env?.portal?.slug ?? ''
  const flagUser: FlagUser = { tenant, ...identity }

  const result = getFlags(rules, flagUser, { onFlagEvaluated: sendFlagToAnalytics })

  if (!result.success) {
    trackError(result.error instanceof Error ? result.error : new Error(String(result.error)))
    return {}
  }

  return result.flags as Flags
}

function sendFlagToAnalytics(details: EvaluationDetails): void {
  const env = getEnv()
  if (!env?.config?.web?.gtm_container_id || !Array.isArray(window.dataLayer)) return

  if (!details.variationId) {
    errorTracker.track('ConfigCat flag is missing variationId', { key: details.key })
  }

  window.dataLayer.push({
    event: 'configcat_flag_evaluated',
    exp_variant_string: `configcat-${details.key}-${details.value}`,
    variation_id: details.variationId ?? `${details.key}-${details.value}`,
  })
}

function trackError(error: Error): void {
  if (hasTrackedError) return
  hasTrackedError = true
  errorTracker.track('ConfigCat embed evaluation failed', {
    cause: error,
  })
}
